import { Model, util } from '@glu/core';

export default Model.extend({
  defaults: {
    sort: {},
    multiColumnSort: {},
    hiddenColumns: [],
    columnsWidth: {},
    columnOrder: [],
    filters: {}
  },
  initialize(attributes, options) {
    this.grid = options.grid;
    this.sendArray = options.array;
    this.savedJSON = this.toJSON();
    this.listenTo(this, 'change', this.update);
  },

  convertToArray(json) {
    return [json.pageSize, json.currentPage, json.sort, json.columnOrder, json.hiddenColumns, json.filters, json.multiColumnSort, json.columnsWidth];
  },
  convertState(json) {
    return this.sendArray ? this.convertToArray(json) : json;
  },
  update() {
    const currentJSON = this.toJSON();

    if (!util.isEqual(currentJSON, this.savedJSON)) {
      this.savedJSON = currentJSON;
      this.grid.trigger('change:state', this.convertState(currentJSON));
    }
  },
  onFiltersLoaded() {
    this.filtersLoaded = true;
  },
  setColumnOrder(columns) {
    const order = [];
    util.each(columns, (column) => {
      order.push(column.field);
    });
    this.set('columnOrder', order);
  },
  setHiddenColumns(columns) {
    const hidden = [];
    util.each(columns, (column) => {
      if (column.condition === false) {
        hidden.push(column.field);
      }
    });
    this.set('hiddenColumns', hidden);
  },
  setFilters(filters) {
    if (!this.filtersLoaded) {
      return;
    }

    const stateFilters = {};
    util.each(filters, filter => {
      stateFilters[filter.field] = !util.isNullOrUndefined(filter.equality) ?
        this.setRangeFilterValue(filter) : filter.value;
    });
    this.set('filters', stateFilters);
  },
  setRangeFilterValue(filter) {
    return {
      equality: filter.equality,
      value: filter.value
    };
  },
  setMultiColumnSort(columns, enabled) {
    let multiColumnData = [];

    if (this.has('multiColumnSort') && !columns) {
      multiColumnData = this.get('multiColumnSort');
    } else if (columns) {
      multiColumnData[0] = columns;
    }

    multiColumnData[1] = enabled;

    this.set('multiColumnSort', multiColumnData);
  },
  setColumnWidths(columns) {
    const columnsObject = {};
    util.each(columns, (column) => {
      if (column.width) {
        columnsObject[column.field] = column.width;
      }
    });

    this.set('columnsWidth', columnsObject);
  }
});
